<template>
  <div
    v-if="formGuid"
    class="cta"
  >
    <FormRender
      :current-step="currentStep"
      :form-guid="formGuid"
      :override-options="formOptions"
      :subscribed-page-guid="pageGuid"
      @apply-step="currentStep = $event"
    />
  </div>
</template>

<script>
import FormRender from 'common/render/FormRender';
import { mapState } from 'vuex';

export default {
  name: 'CTAButton',
  components: { FormRender },
  props: {
    label: {
      type: String,
      default: undefined,
    },
    labelColor: {
      type: String,
      default: '#fff',
    },
    labelFontSize: {
      type: [Number, String],
      default: 17,
    },
  },
  data() {
    return {
      currentStep: 'step1',
    };
  },
  computed: {
    ...mapState('preview', ['preview']),
    pageGuid() {
      const { isBuilder, isPreview } = this.renderComponent.$props;
      return isBuilder || isPreview ? undefined : this.$route.params.pageGuid;
    },
    formOptions() {
      const {
        hasPopup,
        popupCtaLabel,
        popupCtaLeftIcon,
        popupCtaRightIcon,
        popupCtaLeftIconEnabled,
        popupCtaRightIconEnabled,
        popupHeader,
        popupHeaderTextSize,
        popupHeaderTextColor,
        popupHeaderIconColor,
        popupBackground,
      } = this.$parent.$props;

      let linkThanksPage = `${process.env.PAGE_DOMAIN}/${this.$route.params.pageGuid}/thank-you`;

      if (this.preview.digistoreContentLink) {
        linkThanksPage = `${this.preview.digistoreContentLink}?wbf-page-guid=${this.pageGuid}`;
      }

      return {
        hasPopup,
        popupCtaLeftIcon,
        popupCtaRightIcon,
        popupCtaLeftIconEnabled,
        popupCtaRightIconEnabled,
        popupHeader,
        popupHeaderTextSize,
        popupHeaderTextColor,
        popupHeaderIconColor,
        popupBackground,
        linkThanksPage,
        popupCtaLabel: popupCtaLabel || this.label,
        popupButtonBackgroundColor: this.designOptions.activeColor,
        popupButtonBackgroundColorHover: this.designOptions.activeColor,
        popupButtonBorderColor: this.designOptions.activeColor,
        popupButtonTextSize: this.labelFontSize,
        popupButtonTextColor: this.labelColor,
        popupButtonTextColorHover: this.labelColor,
        popupButtonIconColor: this.labelColor,
        popupButtonIconColorHover: this.labelColor,
        primaryColor: this.designOptions.activeColor,
        primaryColorHover: this.designOptions.activeColor,
      };
    },
    renderComponent() {
      return this.$parent.$parent.$parent;
    },
    designOptions() {
      return this.renderComponent.$props.options.designOptions;
    },
    formGuid() {
      return this.renderComponent.$props.formGuid;
    },
  },
};
</script>
